import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Layout from './layout/Layout';
import LedgerViewPage from './pages/LedgerViewPage';
import LedgerDetailPage from './pages/LedgerDetailPage';
import ReceivablesPage from './pages/ReceivablesPage';
import PayablesPage from './pages/PayablesPage';

const App: React.FC = () => (
  <BrowserRouter>
    <AuthGuard>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/ledger" replace />} />
          <Route path="ledger" element={<LedgerViewPage />} />
          <Route path="ledger/:shipmentId" element={<LedgerDetailPage />} />
          <Route path="receivables" element={<ReceivablesPage />} />
          <Route path="payables" element={<PayablesPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGuard>
  </BrowserRouter>
);

export default App;
